import { render, staticRenderFns } from "./PortalBankingDialog.vue?vue&type=template&id=5e73d614&scoped=true&"
import script from "./PortalBankingDialog.vue?vue&type=script&lang=ts&"
export * from "./PortalBankingDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PortalBankingDialog.vue?vue&type=style&index=0&id=5e73d614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e73d614",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VCardText,VDialog,VForm,VIcon,VTextField})
